import React from 'react';
import { useNavigate } from "react-router-dom";
import verified from '../../assets/verified.png';
import '../../css/DirectoryCompany.css';

function DirectoryCompany({ company }) {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/service-company/${company.link_hash}`);
    }

    const companyAddress = (company.city && company.state) ? `${company.city}, ${company.state}` : (company.city ? company.city : (company.state ? company.state : null));

    return (
        <div className="directoryCompanyContainer" onClick={handleClick}>
            <div className="directoryCompanyImage">
                <img src={company.image} alt="Company" />
            </div>
            <div className="directoryCompanyInfoContainer">
                <div className="directoryCompanyName">{company.name}</div>
                {companyAddress && <div className="directoryCompanyLocation">{company.city}, {company.state}</div>}
                <div className="directoryCompanyPhone">{company.phone}</div>
                {company.status === "Active/Verified" ? (<div className="directoryCompanyVerifiedBadge"><img src={verified || ""} alt="Verified"/></div>) : ""}
            </div>
            <div className="directoryCompanyInsightsContainer">
                <div className="directoryCompanyInsight">
                    <div className="directoryCompanyInsightCount">5</div>
                    <div className="directoryCompanyInsightLabel">Connected Agents</div>
                </div>
                <div className="directoryCompanyInsight">
                    <div className="directoryCompanyInsightCount">15</div>
                    <div className="directoryCompanyInsightLabel">Service Records</div>
                </div>
            </div>
        </div>
    );
}

export default DirectoryCompany;
